import(/* webpackMode: "eager" */ "/vercel/path0/keyond/components/LenisProvider/LenisProvider.tsx")